import { useRef } from "react";
import { sectionScroll } from "Helpers/sectionScroll";
import { RxCoverageApplicationProp } from "../../Rx/RxCoverageApplication/RxCoverageApplication";
import Insured from "./Insured/Insured";
import InsuranceContact from "./InsuranceContact/InsuranceContact";
import PaymentInformation from "./PaymentInformation/PaymentInformation";
import ModalPaymentExpiry from "./ModalPaymentExpiry/ModalPaymentExpiry";
import { CS_TOKEN_EXPIRY_ERROR } from "Features/CoverageApplication/Rx/RxCoverageApplication/Reducers/createCoverage.reducer";
import { tokenizerErrors } from "./PaymentInformation/useMicroform";

const CheckoutPage = ({
  rxCoverageApplication,
}: {
  rxCoverageApplication: RxCoverageApplicationProp;
}) => {
  const insuranceContactRef = useRef(null);
  const paymentInfoRef = useRef(null);

  const [state] = rxCoverageApplication;

  const showPaymentExpiryModal =
    state.applicationForm.root.value.payment.token ===
      tokenizerErrors.CS_CAPTURE_CONTEXT_EXPIRY_ERROR ||
    state.purchase.error === CS_TOKEN_EXPIRY_ERROR;

  return (
    <>
      <Insured
        rxCoverageApplication={rxCoverageApplication}
        onConfirm={() => sectionScroll(insuranceContactRef)}
      />
      <div ref={insuranceContactRef}>
        <InsuranceContact
          rxCoverageApplication={rxCoverageApplication}
          onConfirm={() => sectionScroll(paymentInfoRef)}
        />
      </div>
      <div ref={paymentInfoRef}>
        <PaymentInformation rxCoverageApplication={rxCoverageApplication} />
        <ModalPaymentExpiry show={showPaymentExpiryModal} />
      </div>
    </>
  );
};

export default CheckoutPage;
